import { render } from "./IconCustomerReports.vue?vue&type=template&id=cc671f70"
import script from "./IconCustomerReports.vue?vue&type=script&lang=js"
export * from "./IconCustomerReports.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__